export const SHARE_LINK_ICON_SIZE = 18;

export const PROMOTION_POSTED_ON_DATE_FORMAT = 'DD-MMM-YYYY';
